$(function () {
    console.log('JS Loaded');
});
